var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "23",
        height: "17",
        viewBox: "0 0 23 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M11 0L0.5 8.41545L5.47359 12.1695L10.3031 15.7111L23 0L11.5 4L11 0Z",
          fill: _vm.trailColor
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M1.49074 8.95159L6.43939 5.35619L11.3881 8.95159L9.49783 14.7691H3.38096L1.49074 8.95159Z",
          fill: _vm.meteorColor,
          stroke: _vm.meteorStrokeColor,
          "stroke-width": "2"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }